import { Label } from '@src/design-system/label';
import { FormikCountryField } from '@shared/fields/country-field/formik-country-field';
import { Textfield } from '@shared/fields/text-field';

const EditAddressInfo = () => {
  return (
    <div>
      <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
        <p className='text-gray-600 font-medium text-sm mb-2'>
          Address Information
        </p>
        <div className='flex items-start gap-1 mb-3 w-full'>
          <div className='w-1/2'>
            <Textfield
              name='address_line_1'
              type='text'
              placeholder='Address Line 1'
              label='Address Line 1'
              className='w-full'
            />
          </div>
          <div className='w-1/2'>
            <Textfield
              name='address_line_2'
              type='text'
              placeholder='Address Line 2'
              label='Address Line 2'
              className='w-full'
            />
          </div>
        </div>
        <Textfield
          name='city'
          type='text'
          placeholder='ex: Cairo'
          label='City'
          className='mb-3'
        />
        <Textfield
          name='state'
          type='text'
          placeholder='ex: Nasr City'
          label='State/ Province (optional)'
          className='mb-3'
        />
        <div className='mb-3'>
          <Label>Country</Label>
          <FormikCountryField selectName={'country'} />
        </div>
        <Textfield
          name='postal_code'
          type='text'
          placeholder='ex: 12345'
          label='Zip/ Postal Code (optional)'
        />
      </div>
    </div>
  );
};

export default EditAddressInfo;
